/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Step_Event_GroupInputs */



/**
* | output |
* | --- |
* | "Settings" |
*
* @param {New_Project_Step_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_step_event_group = /** @type {((inputs?: New_Project_Step_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Step_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações")
	return /** @type {LocalizedString} */ ("Settings")
});